export const NAV_LINKS = [
  { name: "Home", to: "/" },
  { name: "About", to: "/about" },
  { name: "Services", to: "/services" },
  { name: "Partner", to: "/partner" },
  { name: "Profile", to: "/company-profile" },
  { name: "Careers", to: "/careers" },
  { name: "Contact", to: "/contact" },
];

export const HERO_CHIPS = [
  { label: "AUTOMATION", icon: "Cpu" },
  { label: "STRATEGY", icon: "Target" },
  { label: "MARKETING", icon: "Megaphone" },
  { label: "BRANDING", icon: "Sparkles" },
  { label: "WEB", icon: "Code2" },
];

export const STATS = [
  { value: "150+", label: "PROJECTS DELIVERED", icon: "Users" },
  { value: "98%", label: "CLIENT SATISFACTION", icon: "Smile" },
  { value: "4+", label: "COUNTRIES SERVED", icon: "Globe" },
  { value: "8+", label: "TRUSTED PARTNERS", icon: "Award" },
];

export const SERVICES = [
  { title: "Business Strategy", icon: "Compass", desc: "Market opportunity, competitive positioning, pricing, business model, GTM planning and strategic execution.", bullets: ["ICP and buyer-journey definition", "Pricing and packaging guidance", "Channel priority framework"] },
  { title: "Performance Marketing", icon: "BarChart3", desc: "Google Ads, Meta Ads, LinkedIn Ads, YouTube Ads, remarketing, lead generation and conversion optimization.", bullets: ["Google and Meta campaign setup", "Landing page conversion flow", "Creative testing cadence"] },
  { title: "Automation and CRM", icon: "Workflow", desc: "Lead capture, segmentation, follow-up sequences, approval workflows, dashboards and lifecycle management.", bullets: ["Lead scoring and follow-up rules", "Email and WhatsApp journey mapping", "Live activity and reporting views"] },
  { title: "Brand Identity & Design", icon: "Palette", desc: "Logo, visual identity systems, brand guidelines, messaging, positioning and marketing collateral.", bullets: ["Brand voice and messaging", "Logo and identity system", "Visual language guidelines"] },
  { title: "Website & Development", icon: "Code2", desc: "Corporate websites, e-commerce, landing pages, CMS solutions, UI/UX and responsive builds.", bullets: ["Custom design and build", "Speed and SEO optimization", "Analytics and tracking setup"] },
  { title: "Content Production", icon: "PenTool", desc: "Copywriting, blogs, ad creatives, motion graphics, short-form video, product content and campaign assets.", bullets: ["Content calendar planning", "Short-form video creatives", "Copy that converts"] },
  { title: "AI Solutions & Automation", icon: "Bot", desc: "AI chatbots, assistants, workflow automation, OCR, document processing, predictive analytics and AI agents.", bullets: ["AI chatbots & assistants", "Workflow automation", "Predictive analytics"] },
  { title: "Custom Software", icon: "Boxes", desc: "ERP, CRM, HRMS, inventory, billing, booking platforms, SaaS products and enterprise applications.", bullets: ["SaaS product engineering", "Enterprise applications", "HRMS & billing systems"] },
  { title: "ERP Solutions", icon: "Server", desc: "Finance, accounting, HR, payroll, attendance, inventory, procurement, sales and multi-branch management.", bullets: ["Finance & accounting", "Inventory & procurement", "Multi-branch operations"] },
  { title: "Mobile App Development", icon: "Smartphone", desc: "Android, iOS, Flutter and React Native apps for customers, employees and enterprise mobility.", bullets: ["iOS & Android native", "Flutter & React Native", "Enterprise mobility apps"] },
  { title: "SEO & AEO Optimization", icon: "Search", desc: "Technical SEO, local SEO, keyword strategy and Answer Engine Optimization for ChatGPT, Gemini, Perplexity and voice search.", bullets: ["Technical & on-page SEO", "AEO for AI search engines", "Local SEO & audits"] },
  { title: "Social Media Growth", icon: "Share2", desc: "Content strategy, publishing calendars, community management, engagement campaigns and influencer collaboration.", bullets: ["Content calendar & strategy", "Community management", "Influencer collaborations"] },
  { title: "Email & WhatsApp Marketing", icon: "Mail", desc: "Automated email campaigns, WhatsApp Business API, customer nurturing, newsletters and retention flows.", bullets: ["Lifecycle email flows", "WhatsApp Business API", "Retention & newsletters"] },
  { title: "Analytics & BI", icon: "LineChart", desc: "Google Analytics, Power BI, Looker Studio, KPI dashboards, executive reports and performance insights.", bullets: ["Executive dashboards", "Marketing & sales analytics", "KPI reporting systems"] },
  { title: "Cloud & Infrastructure", icon: "Cloud", desc: "AWS, Azure, GCP, Docker, VPS hosting, CI/CD, monitoring, backups and infrastructure security.", bullets: ["AWS / Azure / GCP setup", "CI/CD pipelines", "Monitoring & backups"] },
  { title: "APIs & Integrations", icon: "Plug", desc: "REST APIs, GraphQL, payment gateways, CRM/ERP integrations, third-party services, webhooks and middleware.", bullets: ["REST & GraphQL APIs", "Payment & CRM integrations", "Webhooks & middleware"] },
  { title: "Cybersecurity", icon: "ShieldCheck", desc: "Vulnerability assessments, penetration testing, security audits, SSL, backups and continuous monitoring.", bullets: ["Vulnerability & pentest", "SSL & backup strategy", "Continuous monitoring"] },
  { title: "HR & Recruitment Tech", icon: "UserCheck", desc: "Recruitment portals, ATS, employee portals, HRMS, payroll, attendance and onboarding systems.", bullets: ["ATS & recruitment portals", "HRMS & payroll", "Onboarding workflows"] },
  { title: "Travel Technology", icon: "Plane", desc: "Travel CRM, booking engines, visa processing, itinerary builders, invoice generators and agency software.", bullets: ["Booking engines", "Travel CRM & itineraries", "Agency management"] },
  { title: "E-Commerce Solutions", icon: "ShoppingBag", desc: "Custom stores, marketplace integrations, payment gateways, shipping automation and loyalty programs.", bullets: ["Custom store builds", "Payment & shipping", "Loyalty & retention"] },
  { title: "UI/UX Design", icon: "Layout", desc: "User research, wireframing, prototyping, design systems and usability testing for products and websites.", bullets: ["Research & wireframes", "Design systems", "Usability testing"] },
  { title: "Digital Transformation", icon: "Rocket", desc: "Process automation, cloud migration, legacy modernization, AI integration and enterprise strategy.", bullets: ["Process automation", "Cloud migration", "Legacy modernization"] },
  { title: "IT Support & Managed Services", icon: "LifeBuoy", desc: "AMC, remote support, software maintenance, system administration, helpdesk and proactive monitoring.", bullets: ["AMC & remote support", "Helpdesk services", "Proactive monitoring"] },
  { title: "Training & Workshops", icon: "GraduationCap", desc: "Hands-on training in AI, Digital Marketing, CRM, Power BI, Excel, Automation and Data Analytics.", bullets: ["AI & automation training", "Data analytics & BI", "Digital marketing bootcamps"] },
];

export const PROCESS = [
  { step: "01", title: "Audit and Direction", desc: "We audit your current funnel, identify losses, and finalize one focused growth objective." },
  { step: "02", title: "Build and Launch", desc: "We deploy campaigns, pages, and content systems that align with your customer journey." },
  { step: "03", title: "Scale and Optimize", desc: "We monitor live data, improve conversion points, and scale channels with the highest ROI." },
];

export const PACKAGES = [
  { name: "Starter Sprint", best: "Small teams with one clear objective", includes: "Strategy, one channel setup, one conversion page", timeline: "3–4 weeks", priority: "Medium" },
  { name: "Growth Engine", best: "Businesses scaling monthly lead generation", includes: "Multi-channel campaigns, content, CRM automation", timeline: "6–8 weeks", priority: "High" },
  { name: "Scale Partnership", best: "Brands needing full growth operations", includes: "Dedicated execution pod + weekly optimization cycle", timeline: "Quarterly retainer", priority: "Critical" },
];

export const CLIENTS = [
  { name: "Vardhaman Group", country: "India", flag: "🇮🇳", industry: "Corporate Group", services: ["End-to-End Technology Support", "Business Operations", "Website Development", "Digital Solutions"] },
  { name: "Vardhamaan Tours & Travels", country: "India & Caribbean", flag: "🇮🇳", industry: "Travel & Tourism", services: ["Travel Technology Platform", "Website Development", "Branding", "Online Booking Solutions", "Digital Marketing"] },
  { name: "SV Hirelink", country: "India", flag: "🇮🇳", industry: "HR Operations & Business Support", services: ["HR Operations", "Recruitment Process Management", "CRM Solutions", "Business Process Automation", "Website Development"] },
  { name: "Vardhamaan Consultancy Services", country: "Qatar", flag: "🇶🇦", industry: "ERP & Business Tech Consulting", services: ["ERP Software Development", "Custom Business Apps", "Digital Transformation", "Website Development", "IT & Branding Consultancy"] },
  { name: "Glitz Aura", country: "India", flag: "🇮🇳", industry: "Luxury Jewellery & Lifestyle Brand", services: ["Luxury Brand Identity", "Logo Design", "Premium Packaging", "Product Catalogue Design", "E-commerce Website", "Social Media Branding"] },
  { name: "AOD Associates", country: "India", flag: "🇮🇳", industry: "Architecture, Engineering & Interiors", services: ["Corporate Website Development", "Company Profile Design", "Digital Branding", "Business Identity Solutions"] },
  { name: "BANGA INTERNATIONAL INC.", country: "Guyana", flag: "🇬🇾", industry: "International Trading & Export", services: ["Corporate Website Development", "Digital Business Solutions", "Technical Support & IT Services"] },
  { name: "Caffeine & Crayons", country: "India", flag: "🇮🇳", industry: "Creative Design & Digital Agency", services: ["End-to-End Technical Support", "Website Development", "Website Maintenance", "UI/UX Support", "Digital Infrastructure"] },
];

export const TESTIMONIALS = [
  { quote: "BUGZ X has been a trusted technology partner, delivering scalable digital solutions, business automation, and reliable technical support.", name: "Vardhaman Group", role: "Corporate Group • India" },
  { quote: "The BUGZ X team developed a modern travel platform that enhanced our customer experience and streamlined our online operations.", name: "Vardhamaan Tours & Travels", role: "Travel & Tourism • India & Caribbean" },
  { quote: "BUGZ X delivered an efficient recruitment platform with seamless automation, improving workflows for candidates and employers.", name: "SV Hirelink", role: "HR Operations • India" },
  { quote: "BUGZ X successfully developed tailored ERP solutions and digital systems that optimized our business processes.", name: "Vardhamaan Consultancy", role: "ERP & Tech Consulting • Qatar" },
  { quote: "BUGZ X transformed our brand into a premium digital experience through elegant branding and a modern website.", name: "Glitz Aura", role: "Luxury Jewellery • India" },
  { quote: "Our collaboration with BUGZ X resulted in a professional corporate website and a stronger digital presence.", name: "AOD Associates", role: "Architecture • India" },
];

export const INTERN_ROLES = [
  { role: "Lead Generation Intern", type: "2 Months", location: "Remote", desc: "Support outbound and inbound pipeline building for service and consulting Partner.", bullets: ["Prospect research and lead list building", "CRM updates and campaign tracking support", "Weekly lead quality and response reporting"] },
  { role: "Video Editor Intern", type: "2 Months", location: "Remote", desc: "Create short-form and ad-ready videos aligned with campaign goals and brand voice.", bullets: ["Edit reels, social shorts, and promo cuts", "Add captions, transitions, and sound polish", "Deliver weekly creative iterations from feedback"] },
  { role: "Content Writer Intern", type: "2 Months", location: "Remote", desc: "Write clear, conversion-focused content for social, landing pages, and campaigns.", bullets: ["Draft post copy, hooks, and campaign captions", "Write website snippets and funnel content", "Assist with content calendars and revisions"] },
  { role: "Full Stack Developer Intern", type: "2 Months", location: "Remote", desc: "Build and improve web features across frontend and backend workflows for client projects.", bullets: ["Implement responsive UI components", "Connect APIs and form workflows", "Fix bugs and support release quality checks"] },
];

export const TEAM = [
  { 
    name: "Vishal Suthar", 
    role: "Founder & Technology Specialist", 
    desc: "Expert in technology solutions, system architecture, and delivering innovative business solutions.", 
    image: "/vishal.png",
    tags: ["Technology Solutions", "System Architecture", "Business Solutions"] 
  },
  { 
    name: "Chirag Mewada", 
    role: "Co-Founder & Brand Designer", 
    desc: "Specializing in brand identity, logo design, positioning strategy, and visual systems that drive long-term business growth.", 
    image: "/chirag.png",
    tags: ["Brand Identity", "Logo Design", "Brand Strategy"] 
  }
];

export const SERVICE_OPTIONS = [
  "Business Strategy",
  "Performance Marketing",
  "Meta Ads and Lead Generation",
  "SEO and AI Search Optimization",
  "Social Media Growth",
  "Brand Identity",
  "Website and Funnels",
  "CRM and Automation",
  "Complete Growth Partnership",
];

export const FORM_TYPES = [
  "Inquiry",
  "Job Application",
  "Business Partnership",
  "Support Request",
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Argentina", "Australia", "Austria",
  "Bahrain", "Bangladesh", "Belgium", "Brazil", "Canada", "Chile", "China",
  "Colombia", "Croatia", "Czech Republic", "Denmark", "Egypt", "Ethiopia",
  "Finland", "France", "Germany", "Ghana", "Greece", "Guyana", "Hong Kong",
  "Hungary", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Lebanon",
  "Libya", "Malaysia", "Mexico", "Morocco", "Netherlands", "New Zealand",
  "Nigeria", "Norway", "Oman", "Pakistan", "Peru", "Philippines", "Poland",
  "Portugal", "Qatar", "Romania", "Russia", "Saudi Arabia", "Senegal",
  "Singapore", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sudan",
  "Sweden", "Switzerland", "Taiwan", "Tanzania", "Thailand", "Tunisia",
  "Turkey", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
  "United States", "Vietnam", "Yemen", "Zimbabwe",
];

export const FAQS = [
  { q: "Can you work with our existing team and tools?", a: "Yes. We integrate with your current CRM, project tools, and ad accounts. Our model complements your team, not replaces it." },
  { q: "Do you support only one niche or multiple industries?", a: "We work across industries. Our systems are built on universal growth principles — lead quality, conversion, and retention — adapted to your specific market." },
  { q: "How soon can we start after onboarding?", a: "Most engagements begin execution within 5–7 business days of the discovery sprint. Priority Partner can accelerate to 48-hour kickoff." },
];

export const VALUES = [
  { title: "Consulting Mindset", desc: "Solve root causes, not surface symptoms." },
  { title: "Execution Depth", desc: "Strategy to campaigns to conversion, end-to-end." },
  { title: "Team Culture", desc: "Honest communication and fast iteration." },
  { title: "Business-First Thinking", desc: "Goals, economics and funnel come before creative production." },
];

export const FOUNDATION = [
  { step: "01", title: "Company Vision", desc: "Become the trusted AI-powered growth and automation partner for ambitious businesses that want measurable execution, not disconnected activity." },
  { step: "02", title: "Mission", desc: "Design and launch practical systems that improve lead quality, response speed, sales visibility, brand trust, and conversion performance." },
  { step: "03", title: "Execution Philosophy", desc: "Audit what exists, identify the highest-leverage bottleneck, build quickly, measure honestly, and optimize around business outcomes." },
  { step: "04", title: "Why We Exist", desc: "Most businesses do not need more tools. They need a cleaner system that connects acquisition, automation, follow-up, and reporting." },
];

export const OPERATING_MODEL = [
  { letter: "A", title: "Discovery Sprint", desc: "Intake calls, asset review, offer analysis, audience segmentation, and KPI alignment." },
  { letter: "B", title: "Build Sprint", desc: "Campaign assets, content plan, landing pages, CRM workflows, and baseline dashboard setup." },
  { letter: "C", title: "Scale Sprint", desc: "Weekly data loops, messaging updates, performance optimization, and channel expansion." },
];

export const TECH_CATEGORIES = [
  { id: "all", label: "All Technologies", count: 32 },
  { id: "ai", label: "AI & Machine Learning", count: 6 },
  { id: "frontend", label: "Frontend & Web", count: 6 },
  { id: "backend", label: "Backend & APIs", count: 6 },
  { id: "database", label: "Databases & Storage", count: 5 },
  { id: "cloud", label: "Cloud & DevOps", count: 5 },
  { id: "automation", label: "Automation & CRM", count: 4 },
];

export const TECH_STACK = [
  // AI & ML
  {
    name: "OpenAI GPT-4o",
    category: "ai",
    icon: "Bot",
    badge: "LLM / Multimodal",
    desc: "Advanced reasoning, agentic tool-use, automated customer service, and structured data extraction.",
    useCase: "Autonomous AI agents, customer inquiry triage, and intelligent assistants.",
    tier: "Production Core"
  },
  {
    name: "Google Gemini",
    category: "ai",
    icon: "Sparkles",
    badge: "1M+ Context / Vision",
    desc: "Ultra long-context analysis, multimodal document understanding, and real-time generation.",
    useCase: "Enterprise document parsing, OCR, video intelligence, and multimodal reasoning.",
    tier: "High Performance"
  },
  {
    name: "Claude 3.5 Sonnet",
    category: "ai",
    icon: "Cpu",
    badge: "Code & Analysis",
    desc: "Industry-leading coding capabilities, complex workflow synthesis, and nuanced copywriting.",
    useCase: "Software synthesis, complex logic workflows, and strategic market research.",
    tier: "Production Core"
  },
  {
    name: "LangChain & LlamaIndex",
    category: "ai",
    icon: "Workflow",
    badge: "RAG & Orchestration",
    desc: "Frameworks for building context-aware, reasoning-grounded LLM applications and vector pipelines.",
    useCase: "Enterprise knowledge base search, semantic RAG systems, and custom agent chains.",
    tier: "Architecture"
  },
  {
    name: "Whisper AI & ElevenLabs",
    category: "ai",
    icon: "Radio",
    badge: "Speech & Audio",
    desc: "State-of-the-art automatic speech recognition (ASR) and lifelike neural voice synthesis.",
    useCase: "Call transcription, meeting analysis, and voice-assisted customer journeys.",
    tier: "AI Native"
  },
  {
    name: "Pinecone & Pgvector",
    category: "ai",
    icon: "Database",
    badge: "Vector Database",
    desc: "High-dimensional vector indexing and similarity search for real-time semantic retrieval.",
    useCase: "Semantic search, AI memory, recommendation engines, and dynamic embeddings.",
    tier: "High Scale"
  },

  // Frontend & Web
  {
    name: "React 19 & React DOM",
    category: "frontend",
    icon: "Code2",
    badge: "Frontend Core",
    desc: "Component-driven, high-performance UI engineering with modern hooks and transitions.",
    useCase: "Responsive web apps, client portals, SaaS interfaces, and conversion engines.",
    tier: "Production Core"
  },
  {
    name: "Next.js & Vite",
    category: "frontend",
    icon: "Zap",
    badge: "SSR & Instant HMR",
    desc: "Server-side rendering, static generation, edge routing, and lightning-fast developer experience.",
    useCase: "SEO-optimized enterprise websites, corporate platforms, and high-conversion landing pages.",
    tier: "Production Core"
  },
  {
    name: "TypeScript",
    category: "frontend",
    icon: "Layers",
    badge: "Type Safety",
    desc: "Strict type definitions, zero runtime type errors, and maintainable enterprise codebases.",
    useCase: "End-to-end type safety between frontend, APIs, and client models.",
    tier: "Enterprise Standard"
  },
  {
    name: "Tailwind CSS",
    category: "frontend",
    icon: "Palette",
    badge: "Utility-First CSS",
    desc: "Atomic, responsive styling with bespoke tokens, glassmorphism, and modern dark/light themes.",
    useCase: "Bespoke design systems, responsive mobile-first layouts, and brand visual styling.",
    tier: "Production Core"
  },
  {
    name: "Framer Motion",
    category: "frontend",
    icon: "Sparkles",
    badge: "Motion & Micro-UX",
    desc: "Physics-based animations, layout transitions, gesture controls, and scroll-driven interactions.",
    useCase: "Micro-interactions, dynamic page loaders, smooth modals, and interactive charts.",
    tier: "UI Excellence"
  },
  {
    name: "Radix UI & Shadcn",
    category: "frontend",
    icon: "Boxes",
    badge: "Accessible Primitives",
    desc: "WAI-ARIA accessible, unstyled headless component primitives for robust user experience.",
    useCase: "Accessible dialogs, dropdowns, sheets, tooltips, and data entry forms.",
    tier: "Production Core"
  },

  // Backend & APIs
  {
    name: "Python 3.11+",
    category: "backend",
    icon: "Terminal",
    badge: "Core Language",
    desc: "High-productivity language powering data processing, AI integrations, and backend logic.",
    useCase: "Business logic, machine learning pipelines, automation scripts, and server backends.",
    tier: "Production Core"
  },
  {
    name: "FastAPI",
    category: "backend",
    icon: "Zap",
    badge: "Async Python Framework",
    desc: "Modern, high-performance async web framework built on Starlette and Pydantic with native OpenAPI docs.",
    useCase: "High-throughput REST APIs, asynchronous workers, and AI endpoint serving.",
    tier: "Production Core"
  },
  {
    name: "Node.js & Express",
    category: "backend",
    icon: "Server",
    badge: "JavaScript Runtime",
    desc: "Event-driven, non-blocking I/O server environment for scalable real-time microservices.",
    useCase: "Microservices, webhook ingestion, real-time sync, and third-party API proxies.",
    tier: "Production Core"
  },
  {
    name: "Go (Golang)",
    category: "backend",
    icon: "Cpu",
    badge: "High Concurrency",
    desc: "Compiled, concurrent language engineered for ultra-low latency, microservices, and network tooling.",
    useCase: "High-volume data pipelines, background daemons, and microservices.",
    tier: "High Scale"
  },
  {
    name: "GraphQL & REST APIs",
    category: "backend",
    icon: "Workflow",
    badge: "API Protocols",
    desc: "Structured query architectures and standardized RESTful contracts with complete documentation.",
    useCase: "Flexible client data fetching, multi-platform mobile API layers, and third-party integrations.",
    tier: "Standard"
  },
  {
    name: "WebSockets & SSE",
    category: "backend",
    icon: "Radio",
    badge: "Real-time Streams",
    desc: "Bi-directional real-time communication channels and server-sent events for live streaming.",
    useCase: "Live chat widgets, streaming AI token responses, and real-time dashboard notifications.",
    tier: "High Performance"
  },

  // Databases & Storage
  {
    name: "Supabase (PostgreSQL)",
    category: "database",
    icon: "Database",
    badge: "Relational + RLS",
    desc: "Open-source Firebase alternative powered by PostgreSQL, real-time listeners, and Row-Level Security.",
    useCase: "Primary relational storage, secure user auth, uploaded document storage, and row policies.",
    tier: "Production Core"
  },
  {
    name: "MongoDB",
    category: "database",
    icon: "Database",
    badge: "NoSQL / Document",
    desc: "Flexible, schema-free document database optimized for rapid prototyping and nested JSON records.",
    useCase: "Dynamic form captures, event logs, analytics payloads, and un-structured content.",
    tier: "High Scale"
  },
  {
    name: "Redis",
    category: "database",
    icon: "Zap",
    badge: "In-Memory Caching",
    desc: "Sub-millisecond latency in-memory data store for caching, rate limiting, and pub/sub message queues.",
    useCase: "API response caching, session stores, rate limiters, and background job queues.",
    tier: "Performance"
  },
  {
    name: "AWS S3 & Cloudflare R2",
    category: "database",
    icon: "Cloud",
    badge: "Object Storage",
    desc: "Unlimited, highly durable object storage with edge content delivery and zero egress fees.",
    useCase: "Resumes, PDF proposals, video assets, brand collateral, and automated backups.",
    tier: "Production Core"
  },
  {
    name: "PostgreSQL",
    category: "database",
    icon: "Database",
    badge: "ACID Compliant",
    desc: "The world's most advanced open source enterprise relational database with jsonb & vector extensions.",
    useCase: "Financial transactions, multi-branch ERP databases, audit trails, and reporting.",
    tier: "Enterprise Standard"
  },

  // Cloud & DevOps
  {
    name: "Amazon Web Services (AWS)",
    category: "cloud",
    icon: "Cloud",
    badge: "Cloud Infrastructure",
    desc: "EC2 compute, Lambda serverless, S3 storage, RDS databases, and Route 53 DNS routing.",
    useCase: "Enterprise hosting, scalable serverless workloads, and distributed file pipelines.",
    tier: "Enterprise Standard"
  },
  {
    name: "Docker & Containerization",
    category: "cloud",
    icon: "Boxes",
    badge: "Containers",
    desc: "Isolated, reproducible application containers for smooth transition from development to production.",
    useCase: "Microservice deployment, consistent local dev environments, and CI build runners.",
    tier: "DevOps Core"
  },
  {
    name: "Vercel & Render",
    category: "cloud",
    icon: "Globe",
    badge: "Edge & Cloud Deployment",
    desc: "Modern zero-config edge cloud deployments with instant rollback, preview branches, and global CDN.",
    useCase: "Frontend hosting, FastAPI web service orchestration, and automated Git CI/CD deployments.",
    tier: "Production Core"
  },
  {
    name: "Cloudflare",
    category: "cloud",
    icon: "ShieldCheck",
    badge: "CDN & Edge Security",
    desc: "Global CDN caching, DDoS mitigation, Web Application Firewall (WAF), and SSL certificate termination.",
    useCase: "DNS management, edge caching, speed optimization, and cyber protection.",
    tier: "Security Standard"
  },
  {
    name: "GitHub Actions CI/CD",
    category: "cloud",
    icon: "Workflow",
    badge: "Continuous Integration",
    desc: "Automated test suites, linter checks, and deployment triggers on every git push.",
    useCase: "Continuous integration, automated builds, security vulnerability scanning, and releases.",
    tier: "DevOps Core"
  },

  // Automation & CRM
  {
    name: "Make.com & n8n",
    category: "automation",
    icon: "Workflow",
    badge: "Workflow Automation",
    desc: "Visual workflow builders connecting disparate SaaS tools, webhooks, databases, and APIs.",
    useCase: "Lead routing, multi-step notification pipelines, data enrichment, and automated reporting.",
    tier: "Automation Core"
  },
  {
    name: "WhatsApp Business API",
    category: "automation",
    icon: "Radio",
    badge: "Conversational Comms",
    desc: "Direct enterprise API for WhatsApp interactive messaging, template broadcasts, and chatbots.",
    useCase: "Instant lead response, booking confirmations, document delivery, and customer re-engagement.",
    tier: "Growth Driver"
  },
  {
    name: "Brevo & Transactional SMTP",
    category: "automation",
    icon: "Mail",
    badge: "Email Deliverability",
    desc: "Dedicated SMTP relays, SPF/DKIM/DMARC authenticated transactional emails, and automated email drips.",
    useCase: "Submission receipts, internal staff alerts, client onboarding sequences, and newsletters.",
    tier: "Production Core"
  },
  {
    name: "Google Analytics 4 & Meta Pixel",
    category: "automation",
    icon: "BarChart3",
    badge: "Measurement & Growth",
    desc: "Server-side conversion tracking (CAPI), UTM attribution modeling, event telemetry, and ROI analytics.",
    useCase: "Conversion rate optimization, paid ad attribution, funnel loss detection, and executive reporting.",
    tier: "Growth Standard"
  }
];

